import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCarousel, { EcoSectionCarouselItemProps } from 'eco-design/sections/eco-section-carousel';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.ListA1');
    const itemsA: EcoSectionCarouselItemProps[] = [
        {
            desc: '',
            icon: '',
            link: 'https://www.ecoflow.com',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745044714795/list_a_1.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745044714795/list_a_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745045421975/list_a_1_h5.jpg',
            target: '_blank',
            title: t('item1_title'),
        },
        {
            desc: '',
            icon: '',
            link: 'https://www.ecoflow.com',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745044760961/list_a_2.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745044760961/list_a_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745045858115/list_a_2_h5.jpg',

            target: '_blank',
            title: t('item2_title'),
        },
        {
            desc: '',
            icon: '',
            link: 'https://www.ecoflow.com',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745044761537/list_a_3.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745044761537/list_a_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745045858275/list_a_3_h5.jpg',

            target: '_blank',
            title: t('item3_title'),
        },
        {
            desc: '',
            icon: '',
            link: 'https://www.ecoflow.com',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745044761133/list_a_4.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745044761133/list_a_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745045858461/list_a_4_h5.jpg',

            target: '_blank',
            title: t('item4_title'),
        },
        {
            desc: '',
            icon: '',
            link: 'https://www.ecoflow.com',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745044761336/list_a_5.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745044761336/list_a_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745045858654/list_a_5_h5.jpg',

            target: '_blank',
            title: t('item5_title'),
        },
    ];
    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCarousel headerLayout="header-bottom" items={itemsA} title={t('title')} />
        </div>
    );
}
